import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface FacetListButtonTextProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: string
    $isOnSecondRow?: boolean
}

const FacetListButtonText = memo(({templating, children, $isOnSecondRow}: FacetListButtonTextProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName $isOnSecondRow={$isOnSecondRow}>{children}</ComponentName>
        </Suspense>
    )
})
FacetListButtonText.displayName = "FacetListButtonText"

export default connect(FacetListButtonText)
